<template>

    <trax-ui-ajax-form-in-modal :id="id" :toastr-id="toastrId" :endpoint="endpoint" 
        :props="props" :titles="titles" :form="form" :bus="bus" icons="1">

        <trax-ui-input type="text" icon="text_fields" :placeholder="inputPlaceholder"
            v-model="form.name" :error="errors.name" required="1" :rows="inputRows">
        </trax-ui-input>

        <trax-ui-select icon="playlist_add_check" v-model="form.competencies" v-show="form.parent_id && !this.form.title"
            :options="competency_domains_select" multiple="1" :none-selected-text="lang.polaris.training.competencies+'...'"
            :error="errors.competencies" required="1">
        </trax-ui-select>
     
    </trax-ui-ajax-form-in-modal>
    
</template>

<script>
    export default {

        props: ['bus', 'id', 'toastrId', 'endpoint', 'itemRows'],
    
        data: function() {
            return {
                lang: lang,
                competency_domains_select: data.competency_domains_select,
                form: {},
                errors: {},
                props: {
                    id: { source:'id' },
                    index_id: { source:'index_id' },
                    parent_id: { source:'parent_id' },
                    type: { source:'type' },
                    order: { source:'order' },
                    title: { source:'title' },
                    name: { source:'name' },
                    competencies: { source:'competencies' }
                },
                titles: {
                    new: lang.polaris.common.new_indicator,
                    update: lang.polaris.form.item_update
                }
            }
        },

        computed: {

            inputPlaceholder: function() {
                if (this.form.parent_id && !this.form.title && this.itemRows) return this.lang.polaris.form.description;
                return this.lang.polaris.form.name;
            },

            inputRows: function() {
                if (this.form.parent_id && !this.form.title && this.itemRows) return this.itemRows;
            }
        },

        created: function() {
            var that = this;

            this.bus.$on(this.id+'-errors', function(errors) {
                that.errors = errors;
            });

            this.bus.$on(this.id+'-data', function(data) {
                that.form = data;
            });
        }
    }
</script>
